import React from "react";
import { PreviewSocialNetworks } from "@/features/previews/shared/components/PreviewSocialNetworks";
import { InitPreviewSocialLogos } from "@/features/previews/shared/components/InitPreviewSocialLogos/InitPreviewSocialLogos";

import type { QRProps } from "@/contexts/QREditorContext/types";

interface WebsiteSocialSectionProps {
  data: NonNullable<QRProps<"website">["data"]>;
  isInitialPreview: boolean;
}

export const WebsiteSocialSection = ({ data, isInitialPreview }: WebsiteSocialSectionProps) => {
  if (data?.socialNetworks?.length > 0) {
    return (
      <PreviewSocialNetworks
        networks={data.socialNetworks}
        variant="website"
        className="website-template__social-networks"
      />
    );
  }

  if (isInitialPreview) {
    return (
      <div>
        <InitPreviewSocialLogos
          type="website"
          className="website-template__social-logos"
        />
      </div>
    );
  }

  return null;
};
